"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Fortbildung = _interopRequireDefault(require("../model/Fortbildung"));

var _FortbildungCreate = _interopRequireDefault(require("../model/FortbildungCreate"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Fortbildung service.
* @module api/FortbildungApi
* @version 0.0.1
*/
var FortbildungApi = /*#__PURE__*/function () {
  /**
  * Constructs a new FortbildungApi. 
  * @alias module:api/FortbildungApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function FortbildungApi(apiClient) {
    _classCallCheck(this, FortbildungApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the createFortbildungFortbildungPost operation.
   * @callback module:api/FortbildungApi~createFortbildungFortbildungPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Fortbildung} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Fortbildung
   * @param {module:model/FortbildungCreate} fortbildungCreate 
   * @param {module:api/FortbildungApi~createFortbildungFortbildungPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Fortbildung}
   */


  _createClass(FortbildungApi, [{
    key: "createFortbildungFortbildungPost",
    value: function createFortbildungFortbildungPost(fortbildungCreate, callback) {
      var postBody = fortbildungCreate; // verify the required parameter 'fortbildungCreate' is set

      if (fortbildungCreate === undefined || fortbildungCreate === null) {
        throw new Error("Missing the required parameter 'fortbildungCreate' when calling createFortbildungFortbildungPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['JWTBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Fortbildung["default"];
      return this.apiClient.callApi('/fortbildung/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteFortbildungFortbildungFortbildungIdDelete operation.
     * @callback module:api/FortbildungApi~deleteFortbildungFortbildungFortbildungIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {Object} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete Fortbildung
     * @param {Number} fortbildungId 
     * @param {module:api/FortbildungApi~deleteFortbildungFortbildungFortbildungIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Object}
     */

  }, {
    key: "deleteFortbildungFortbildungFortbildungIdDelete",
    value: function deleteFortbildungFortbildungFortbildungIdDelete(fortbildungId, callback) {
      var postBody = null; // verify the required parameter 'fortbildungId' is set

      if (fortbildungId === undefined || fortbildungId === null) {
        throw new Error("Missing the required parameter 'fortbildungId' when calling deleteFortbildungFortbildungFortbildungIdDelete");
      }

      var pathParams = {
        'fortbildung_id': fortbildungId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['JWTBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the readFortbildungFortbildungFortbildungIdGet operation.
     * @callback module:api/FortbildungApi~readFortbildungFortbildungFortbildungIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Fortbildung} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Read Fortbildung
     * @param {Number} fortbildungId 
     * @param {Object} opts Optional parameters
     * @param {String} [userId = '')] User id des angemeldeten Nutzers, um zu überprüfen welche Fortbildungen bereits gebucht wurden.
     * @param {module:api/FortbildungApi~readFortbildungFortbildungFortbildungIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Fortbildung}
     */

  }, {
    key: "readFortbildungFortbildungFortbildungIdGet",
    value: function readFortbildungFortbildungFortbildungIdGet(fortbildungId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'fortbildungId' is set

      if (fortbildungId === undefined || fortbildungId === null) {
        throw new Error("Missing the required parameter 'fortbildungId' when calling readFortbildungFortbildungFortbildungIdGet");
      }

      var pathParams = {
        'fortbildung_id': fortbildungId
      };
      var queryParams = {
        'user_id': opts['userId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Fortbildung["default"];
      return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the readFortbildungenFortbildungGet operation.
     * @callback module:api/FortbildungApi~readFortbildungenFortbildungGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Fortbildung>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Read Fortbildungen
     * @param {Object} opts Optional parameters
     * @param {Number} [skip = 0)] Einträge die beim Abrufen aus der Datenbank übersprungen werden sollen.
     * @param {Number} [limit = 100)] Anzahl der Einträge die abgerufen werden sollen.
     * @param {String} [typ = 'kfv')] Typ der Fortbildung. Entweder 'kfv' oder 'kjf'
     * @param {String} [userId = '')] User id des angemeldeten Nutzers, um zu überprüfen welche Fortbildungen bereits gebucht wurden.
     * @param {Boolean} [showAll = false)] Standardmäßig werden nur nicht ausgelaufene Fortbildungen angezeigt. Ist diese Feld wahr, werden alle angezeigt.
     * @param {Boolean} [showMine = false)] Standardmäßig werden alle Fortbildungen angezeigt. Ist diese Feld wahr, werden nur die selbst gebuchten Fortbildungen angezeigt.
     * @param {module:api/FortbildungApi~readFortbildungenFortbildungGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Fortbildung>}
     */

  }, {
    key: "readFortbildungenFortbildungGet",
    value: function readFortbildungenFortbildungGet(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'skip': opts['skip'],
        'limit': opts['limit'],
        'typ': opts['typ'],
        'user_id': opts['userId'],
        'showAll': opts['showAll'],
        'showMine': opts['showMine']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_Fortbildung["default"]];
      return this.apiClient.callApi('/fortbildung/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the updateFortbildungFortbildungFortbildungIdPatch operation.
     * @callback module:api/FortbildungApi~updateFortbildungFortbildungFortbildungIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FortbildungCreate} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Fortbildung
     * @param {Number} fortbildungId 
     * @param {module:model/FortbildungCreate} fortbildungCreate 
     * @param {module:api/FortbildungApi~updateFortbildungFortbildungFortbildungIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FortbildungCreate}
     */

  }, {
    key: "updateFortbildungFortbildungFortbildungIdPatch",
    value: function updateFortbildungFortbildungFortbildungIdPatch(fortbildungId, fortbildungCreate, callback) {
      var postBody = fortbildungCreate; // verify the required parameter 'fortbildungId' is set

      if (fortbildungId === undefined || fortbildungId === null) {
        throw new Error("Missing the required parameter 'fortbildungId' when calling updateFortbildungFortbildungFortbildungIdPatch");
      } // verify the required parameter 'fortbildungCreate' is set


      if (fortbildungCreate === undefined || fortbildungCreate === null) {
        throw new Error("Missing the required parameter 'fortbildungCreate' when calling updateFortbildungFortbildungFortbildungIdPatch");
      }

      var pathParams = {
        'fortbildung_id': fortbildungId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['JWTBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _FortbildungCreate["default"];
      return this.apiClient.callApi('/fortbildung/{fortbildung_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return FortbildungApi;
}();

exports["default"] = FortbildungApi;